import { Tab, TabList, Tabs } from "@archery-inc/design-system";
import { FormattedMessage } from "react-intl";
import { Outlet, useNavigate } from "@tanstack/react-router";

export default function NavigationLayout() {
  const navigate = useNavigate();
  return (
    <>
      <Tabs
        className="fixed w-full bg-white/90 backdrop-blur-lg z-10"
        selectedKey={window.location.pathname}
        onSelectionChange={(k) => void navigate({ to: k as string })}
      >
        <TabList className="w-full h-12">
          <Tab id="/" variant="fullwidth" className="w-1/2" leftIcon="sparkle">
            <FormattedMessage id="ai_reveal_create_tab_title" />
          </Tab>
          <Tab
            id="/my-generations"
            variant="fullwidth"
            className="w-1/2"
            leftIcon="projects_outline"
          >
            <FormattedMessage id="ai_reveal_my_generations_tab_title" />
          </Tab>
        </TabList>
      </Tabs>
      <div className="pt-16 px-16">
        <Outlet />
      </div>
    </>
  );
}
